import { DEPARTMENTS, AGENTS, getAgentBySlug } from '../../utils/agents';
import type { AgentInfo } from '../../utils/agents';
import { DepartmentCard } from './DepartmentCard';

// Map department ID → department key used in agent.department
const DEPT_ID_TO_KEY: Record<string, string> = {
  '00': '00-Admin',
  '01': '01-Brand',
  '02': '02-Products',
  '03': '03-Campaigns',
  '04': '04-Content',
  '05': '05-Email',
  '06': '06-Socials',
  '07': '07-Ads',
  '08': '08-Website',
  '09': '09-UGC',
  '10': '10-Marketplaces',
  '11': '11-Analytics',
  '12': '12-Finance',
  '13': '13-Codebases',
};

function getCSuiteParent(agents: AgentInfo[]): AgentInfo | undefined {
  if (agents.length === 0) return undefined;
  const parentSlug = agents[0].reportsTo;
  return getAgentBySlug(parentSlug);
}

export function DepartmentGrid() {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-text-primary">Departments</h2>
        <span className="text-xs text-text-muted">{DEPARTMENTS.length} departments</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {DEPARTMENTS.map((dept) => {
          const deptKey = DEPT_ID_TO_KEY[dept.id];
          const deptAgents = AGENTS.filter((a) => a.department === deptKey);
          const cSuiteParent = getCSuiteParent(deptAgents);

          return (
            <DepartmentCard
              key={dept.id}
              id={dept.id}
              name={dept.name}
              agents={deptAgents}
              cSuiteParent={cSuiteParent}
            />
          );
        })}
      </div>
    </div>
  );
}

export default DepartmentGrid;
